<div style="margin-top: 10px;">
  <form [formGroup]="directEntityListForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row" style="margin-top: 20px;">
          @if (addPermission) {
            <a class="__add_client" (click)="openEntityForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Direct Entity
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <div class="table-scroll-container">
            <mat-table matSort [dataSource]="directEntityDataSource" (matSortChange)="sortData($event)">
              <ng-container matColumnDef="code">
                <mat-header-cell *matHeaderCellDef class="header">
                  <div class="sorting_header">
                    <span mat-sort-header>Entity Code</span>
                    <input placeholder="Search by Code" type="search" matInput
                      autocomplete="off" formControlName="code" class="mat-input-custom">
                    </div>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">{{element.code}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="name">
                  <mat-header-cell *matHeaderCellDef class="header">
                    <div class="sorting_header">
                      <span mat-sort-header>Entity Name</span>
                      <input placeholder="Search by Name" type="search" matInput
                        autocomplete="off" formControlName="name" class="mat-input-custom">
                      </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">{{element.name}}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="cityName">
                    <mat-header-cell *matHeaderCellDef class="header">
                      <div class="sorting_header">
                        <span mat-sort-header>City</span>
                        <input placeholder="Search by City" type="search" matInput
                          autocomplete="off" formControlName="cityName" class="mat-input-custom">
                        </div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">{{element.address?.cityName}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="countryName">
                      <mat-header-cell *matHeaderCellDef class="header">
                        <div class="sorting_header">
                          <span mat-sort-header>Country</span>
                          <input placeholder="Search by Country" type="search" matInput
                            autocomplete="off" formControlName="countryName" class="mat-input-custom">
                          </div>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">{{element.address?.countryName}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="action">
                        <mat-header-cell *matHeaderCellDef>
                          <span class="mat-sort-header-content" >Action</span>
                        </mat-header-cell>
                        <mat-cell class="__action_row" *matCellDef="let element">
                          <span class="__action_edit_icon" (click)="openEntityForm(element.id)" style="margin-right: 10px;">
                            <mat-icon>create</mat-icon>
                          </span>
                        </mat-cell>
                      </ng-container>
                      <mat-header-row *matHeaderRowDef="directEntityColumns; sticky: true" style="background-color: aliceblue;"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: directEntityColumns;"></mat-row>
                    </mat-table>
                  </div>
                }
              </mat-card-content>
            </mat-card>
            @if (viewPermission) {
              <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="totalRecords" showFirstLastButtons></mat-paginator>
            }
          </form>
        </div>
